import {Directive, HostBinding, HostListener, Input} from '@angular/core';

const DEFAULT_ZONE_NAME = 'default';
const DRAG_DATA_TYPE = 'application/tfl-drop-data';

@Directive({
    selector: '[tflDraggable]'
})
export class DraggableDirective {


    private options: DraggableOptions;

    @HostBinding('draggable')
    get draggable() {
        return true;
    }

    @Input()
    set tflDraggable(options: DraggableOptions) {
        if (options) {
            this.options = options;
        }
    }

    @HostListener('dragstart', ['$event'])
    onDragStart(event) {
        let data = {
            data: this.options.data,
            zone: this.options.targetZone || DEFAULT_ZONE_NAME
        };
        event.dataTransfer.setData(DRAG_DATA_TYPE,
            JSON.stringify(data));
    }
}

export interface DraggableOptions {
    data: any;
    targetZone?: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/drag-and-drop/draggable.directive.ts